import { libraryKind } from "./library-kind";

export type LibraryTone = "site" | "app" | "code" | "page" | "slides" | "image" | "file";
const CODE_EXTENSIONS = new Set([
  "js",
  "jsx",
  "ts",
  "tsx",
  "json",
  "css",
  "scss",
  "py",
  "sh",
  "sql",
  "yaml",
  "yml",
  "xml",
  "c",
  "cpp",
  "h",
  "rs",
  "go",
  "java",
  "rb",
  "php",
  "vue",
  "svelte",
  "toml",
]);
export function libraryTone(item: {
  name: string;
  mimeType: string;
  isApp?: boolean;
}): LibraryTone {
  const kind = libraryKind(item);
  if (kind === "apps") return "app";
  if (kind === "sites") return "site";
  if (kind === "images") return "image";
  if (kind === "slides") return "slides";
  if (
    CODE_EXTENSIONS.has(item.name.toLowerCase().split(".").at(-1) ?? "") ||
    ["application/json", "application/javascript", "application/xml"].includes(
      item.mimeType.split(";")[0]!,
    )
  )
    return "code";
  return kind === "pages" ? "page" : "file";
}
export const libraryIconColors: Record<LibraryTone, string> = {
  site: "text-library-site",
  app: "text-library-app",
  code: "text-library-code",
  page: "text-library-page",
  slides: "text-library-slides",
  image: "text-library-image",
  file: "text-muted-foreground",
};
export const libraryIconPlates: Record<LibraryTone, string> = {
  site: "bg-library-site/10",
  app: "bg-library-app/10",
  code: "bg-library-code/10",
  page: "bg-library-page/10",
  slides: "bg-library-slides/10",
  image: "bg-library-image/10",
  file: "bg-accent",
};
